import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Transition as _Transition, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "flex gap-x-10 mt-12"
}
const _hoisted_4 = { class: "mx-2 lowercase" }
const _hoisted_5 = { class: "mx-2 lowercase" }
const _hoisted_6 = {
  key: 0,
  class: "px-x2"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-wrap gap-18"
}
const _hoisted_9 = { class: "sr-only" }

import {
    CustomizerOptionDisplayType,
    CustomizerTabFacet, CustomizerTabFacetType,
    CustomizerTabModel,
    CustomizerTabType,
} from '@/types/productServerApi';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import { computed, ref, toRef, watch } from 'vue';
import type { Component } from 'vue';
import CustomizerMiniTabSwatch from '@/shared/product/customizer/ui/tabs/CustomizerMiniTabSwatch.vue';
import CustomizerMiniTabText from '@/shared/product/customizer/ui/tabs/CustomizerMiniTabText.vue';
import CustomizerMiniTabDefault from '@/shared/product/customizer/ui/tabs/CustomizerMiniTabDefault.vue';
import CustomizerMiniButton from '@/shared/product/customizer/ui/CustomizerMiniButton.vue';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import useProductDetailConfigurator from '@/shared/product/details/useProductDetailConfigurator';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';
import ModuleConfiguratorButton from '@/shared/product/details/ui/module-configurator/ModuleConfiguratorButton.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniTab',
  props: {
    tab: null
  },
  setup(__props: any) {

const props = __props as {
    tab: CustomizerTabModel,
}



const { getMaterialAndColorCustomizerTabFacet, getProductFamilyCustomizerTabFacet, setActiveCustomizerOverlay, getDefaultCustomizerTabFacet, getComfortCustomizerTabFacet, getLegsCustomizerTabFacet } = useCustomizer();
const facet = ref<CustomizerTabFacet>({} as CustomizerTabFacet);
const { link: configurator } = useProductDetailConfigurator();
const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);

const { is3DConfiguratorFeatureEnabled, setInitialLegs, toggleConfigurator, resetConfigurator, configurationLabels } = useModuleConfigurator();

const has3dConfiguration = computed(() => {
    const configuration = is3DConfiguratorFeatureEnabled.value && configurationId.value;
    return configuration;
});

const labels = useBlockLabels();

const handleAction = () => {
    setActiveCustomizerOverlay(props.tab.id, props.tab.type);
};

const init = async() => {
    facet.value = await getFacetData();

    if (is3DConfiguratorFeatureEnabled.value && props.tab.type === CustomizerTabType.Default) {
        const imageId = facet.value?.dimensions?.[0].options.find(x => x.selected)?.image.path;
        const extractedLegMaterial = imageId.split('/materials/')[1].split('.webp')[0]; // TODO: This is a temporary solution, we need to find a better way to extract the leg material

        setInitialLegs(extractedLegMaterial);
    }
};

const getFacetData = async() => {
    switch (props.tab.type) {
    case CustomizerTabType.Variant:
        return await getDefaultCustomizerTabFacet(props.tab.id);
    case CustomizerTabType.ProductFamily:
        return await getProductFamilyCustomizerTabFacet(props.tab.id);
    case CustomizerTabType.MaterialAndColor:
        return await getMaterialAndColorCustomizerTabFacet(props.tab.id);
    case CustomizerTabType.Comfort:
        return await getComfortCustomizerTabFacet(props.tab.id);
    case CustomizerTabType.Legs:
        return await getLegsCustomizerTabFacet(props.tab.id);
    default:
        return await getDefaultCustomizerTabFacet(props.tab.id);
    }
};

const getOptionsComponentByDisplayType = (type?: CustomizerOptionDisplayType): Component => {
    switch (type) {
    case CustomizerOptionDisplayType.Swatch:
        return CustomizerMiniTabSwatch;
    case CustomizerOptionDisplayType.Text:
        return CustomizerMiniTabText;
    default:
        return CustomizerMiniTabDefault;
    }
};

const shouldShowDescription = computed<boolean>(() => {
    const hasDescription = props.tab.description;
    const hasOtherTypeThanText = facet.value.dimensions?.find(dimension => dimension.type !== CustomizerOptionDisplayType.Text) ?? false;
    return hasDescription && hasOtherTypeThanText;
});

const tabToWatchForData = toRef(props, 'tab');
watch(tabToWatchForData, init, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (facet.value.type === _unref(CustomizerTabFacetType).WithOutDimensions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, {
            name: "o-anim-fade-200",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex-wrap gap-x-18 gap-y-10", { flex: !_unref(configurator)?.url && !_unref(is3DConfiguratorFeatureEnabled)}])
              }, [
                (__props.tab.description && !_unref(has3dConfiguration))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: __props.tab.description,
                      class: _normalizeClass({ 'mb-5': _unref(configurator)?.url})
                    }, _toDisplayString(__props.tab.description), 3))
                  : _createCommentVNode("", true),
                (_unref(has3dConfiguration))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(configurationLabels)?.name), 1))
                  : _createCommentVNode("", true),
                (_unref(is3DConfiguratorFeatureEnabled))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_unref(has3dConfiguration))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(ModuleConfiguratorButton, {
                              label: _unref(labels).editYourDesign,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleConfigurator)()))
                            }, null, 8, ["label"]),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(labels).delimiterTextBetweenLinks), 1),
                            _createVNode(ModuleConfiguratorButton, {
                              label: _unref(labels).goBackToStart,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(resetConfigurator)()))
                            }, null, 8, ["label"])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(ModuleConfiguratorButton, {
                              label: _unref(labels).designYourSelfish,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(toggleConfigurator)()))
                            }, null, 8, ["label"]),
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(labels).delimiterTextBetweenLinks), 1),
                            (facet.value.action)
                              ? (_openBlock(), _createBlock(CustomizerMiniButton, {
                                  key: 0,
                                  onClick: handleAction
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(BlockLabelWithNamedArguments, {
                                      tag: "a",
                                      label: facet.value.action
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(configurator)?.url && !_unref(is3DConfiguratorFeatureEnabled))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createVNode(RouterLinkConditional, {
                        to: _unref(configurator).url,
                        "spa-enabled": _unref(configurator).spaLink,
                        title: _unref(labels).designYourSelfish,
                        class: "c-link c-magic-line c-magic-line--underline whitespace-nowrap"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(labels).designYourSelfish), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "spa-enabled", "title"]),
                      (facet.value.action)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(labels).delimiterTextBetweenLinks), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (facet.value.action && !_unref(is3DConfiguratorFeatureEnabled))
                  ? (_openBlock(), _createBlock(CustomizerMiniButton, {
                      key: 4,
                      onClick: handleAction
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BlockLabelWithNamedArguments, {
                          tag: "a",
                          label: facet.value.action
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_Transition, {
            name: "o-anim-fade-200",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_unref(shouldShowDescription))
                ? (_openBlock(), _createElementBlock("div", {
                    key: __props.tab.description,
                    class: "mb-x2"
                  }, _toDisplayString(__props.tab.description), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (!_unref(has3dConfiguration))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", _hoisted_9, _toDisplayString(__props.tab.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facet.value.dimensions, (dimension, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: dimension.type + idx,
                      class: _normalizeClass(["flex flex-row flex-wrap mb-x3 gap-y-18 lg:gap-y-10 last:mb-0", { 'gap-x-18 lg:gap-x-10': dimension.type !== _unref(CustomizerOptionDisplayType).Text }])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getOptionsComponentByDisplayType(dimension.type)), {
                        id: __props.tab.id+idx,
                        options: dimension.options
                      }, null, 8, ["id", "options"]))
                    ], 2))
                  }), 128))
                ]),
                (facet.value.action)
                  ? (_openBlock(), _createBlock(CustomizerMiniButton, {
                      key: 0,
                      onClick: handleAction
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BlockLabelWithNamedArguments, {
                          tag: "a",
                          label: facet.value.action
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})